import { memo } from 'react';
import PublicationDetailMobileRefactored from '../../../PublicationDetailMobile/PublicationDetailMobileRefactored';
import { PublicationHeaderProps } from '../../interfaces';
import styles from '../../publicationDetail.module.scss';

const PublicationHeader = ({
  vehicleTypeSelected,
  publication,
  brand,
  type,
  selectedVersion,
  setSelectedVersion,
  loading,
  children,
  logoDealerships,
  handleDealerLogoClick,
  onLinzeCheckClick,
  onAutoFinClick,
  brandsDealerships,
  selectedDealership,
  setSelectedDealership,
  setOpenAdditionalModal,
  showNegotiationInProgress
}: PublicationHeaderProps) => {
  return (
    <>
      <h1 className={styles.titleSEO}>
        Auto {vehicleTypeSelected === 'new' ? 'nuevo' : 'usado'} {publication?.vehicle_data?.brand} - Chile
      </h1>
      <PublicationDetailMobileRefactored
        brand={brand}
        type={type}
        publication={publication}
        selectedVersion={selectedVersion}
        setSelectedVersion={setSelectedVersion}
        loading={loading}
        children={children}
        logoDealerships={logoDealerships}
        handleDealerLogoClick={handleDealerLogoClick}
        onLinzeCheckClick={onLinzeCheckClick}
        onAutoFinClick={onAutoFinClick}
        vehicleTypeSelected={vehicleTypeSelected}
        brandsDealerships={brandsDealerships}
        selectedDealership={selectedDealership}
        setSelectedDealership={setSelectedDealership}
        setOpenAdditionalModal={setOpenAdditionalModal}
        showNegotiationInProgress={showNegotiationInProgress}
      />
    </>
  );
};

export default memo(PublicationHeader);
